"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_rating_1 = require("@hotelplan/components.common.rating");
const components_common_tooltip_1 = require("@hotelplan/components.common.tooltip");
const ICON_WIDTH_MD = 28;
const ICON_HALF_WIDTH_MD = 10;
const TripAdvisorWrapper = styled_components_1.default.div(({ theme }) => theme.tripAdvisor.ratingWrap);
const TARating = (0, styled_components_1.default)(components_common_rating_1.Rating)(({ theme: { space, media, colors, fontSizes } }) => ({
    alignItems: 'center',
    color: colors.primary,
    marginRight: space[2],
    [media.tablet]: {
        fontSize: fontSizes[3],
        marginRight: space[1],
    },
    '.icon': {
        marginRight: space[1],
    },
}));
const TAIcon = (0, styled_components_1.default)(components_common_icon_1.Icon)(({ theme, ratingSize }) => { var _a, _b; return ratingSize ? (_b = (_a = theme.tripAdvisor) === null || _a === void 0 ? void 0 : _a[ratingSize]) === null || _b === void 0 ? void 0 : _b.icon : {}; }, ({ theme: { space } }) => ({
    marginRight: space[1],
}));
const TripAdvisorRating = props => {
    const { rating, label, size, tooltip } = props, divProps = __rest(props, ["rating", "label", "size", "tooltip"]);
    const tooltipElRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function adjustTooltipPosition() {
        if (!tooltipElRef.current)
            return;
        (0, components_common_tooltip_1.setTooltipPosition)(tooltipElRef.current, {
            tooltipTargetObjectWidth: ICON_WIDTH_MD,
            tooltipTargetObjectHalfWidth: ICON_HALF_WIDTH_MD,
        });
    }, [tooltipElRef]);
    return (react_1.default.createElement(TripAdvisorWrapper, Object.assign({}, divProps),
        react_1.default.createElement(TARating, { maxRating: 5, rating: (rating || 0) / 10, ratingContent: react_1.default.createElement(TAIcon, { name: "tripadvisorone", ratingSize: size }), halfWayRatingContent: react_1.default.createElement(TAIcon, { name: "tripadvisorhalf", ratingSize: size }), remainRatingContent: react_1.default.createElement(TAIcon, { name: "tripadvisorempty", ratingSize: size }) }),
        label,
        !!tooltip && (react_1.default.createElement(components_common_tooltip_1.Tooltip, { withAutoPositioning: true, tooltipElRef: tooltipElRef }, tooltip))));
};
exports.default = TripAdvisorRating;
//# sourceMappingURL=TripAdvisorRaiting.js.map